import { render, staticRenderFns } from "./text.vue?vue&type=template&id=a78bc4a2&scoped=true&"
import script from "./text.vue?vue&type=script&lang=js&"
export * from "./text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78bc4a2",
  null
  
)

export default component.exports